import { fetchNewPasswordDetails } from "../../redux/reducers/AuthReducer";
import { connect } from "react-redux";
import { compose, withHandlers, withState } from "recompose";
import { Alerts } from "../../redux/constants/Values";

export const queryChange = ({ setUpdatePassword, UpdatePassword }) => (
  props
) => {
  setUpdatePassword({
    ...UpdatePassword,
    [props.target.name]: [props.target.value],
  });
};

export const handleSubmit = ({ UpdatePassword, setloader, history }) => async (
  e
) => {
  e.preventDefault();
  e.persist();
  if (
    UpdatePassword.newPassword[0].length >= 10 &&
    UpdatePassword.newPassword[0].match(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{10,})/
    ) &&
    UpdatePassword.confirmPassword[0].length >= 10 &&
    UpdatePassword.confirmPassword[0].match(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{10,})/
    )
  ) {
    if (UpdatePassword.newPassword[0] === UpdatePassword.confirmPassword[0]) {
      setloader(true);
      await fetchNewPasswordDetails(
        UpdatePassword.verificationCode[0],
        UpdatePassword.newPassword[0],
        history
      );
      setloader(true);
    } else {
      window.alert(Alerts.passwordMismatch);
    }
  } else {
    window.alert(Alerts.passwordRequired);
  }
};

export default compose(
  connect(null, { fetchNewPasswordDetails }),
  withState("UpdatePassword", "setUpdatePassword", {
    verificationCode: "",
    newPassword: "",
    confirmPassword: "",
  }),
  withState("loader", "setloader", false),
  withHandlers({ queryChange, handleSubmit })
);
